import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import NewsForm from './NewsForm';
import FormToolbar from '../shared/FormToolbar';

const NewsEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <NewsForm {...props} />
    </SimpleForm>
  </Edit>
);

export default NewsEdit;
